import PrestartPage from "../../day/reports/Prestart";

/**
 * Dataset report: every prestart for this source on the selected day.
 * Same layout as the fleet start page, with one row per start time instead of one row per boat.
 */
export default function DatasetPrestarts() {
  return <PrestartPage mode="dataset" />;
}
